import { render, staticRenderFns } from "./CampusComponent.vue?vue&type=template&id=4aec004d&"
import script from "./CampusComponent.vue?vue&type=script&lang=js&"
export * from "./CampusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports